import { NotificationDefinition } from '../../types'
import { QuoteSignatureRequestFailedHeader } from './QuoteSignatureRequestFailedHeader'
import { QuoteSignatureRequestFailedListItem } from './QuoteSignatureRequestFailedListItem'
import { QuoteSignatureRequestFailedPreview } from './QuoteSignatureRequestFailedPreview'

export const quoteSignatureRequestFailedDefinition: NotificationDefinition = {
  listItemContent: QuoteSignatureRequestFailedListItem,
  previewHeaderContent: QuoteSignatureRequestFailedHeader,
  previewContent: QuoteSignatureRequestFailedPreview
}
